import { createAction } from '@reduxjs/toolkit'
import type { ToastMessage } from '@axilon-apps/libs-ui-types'

export const feedbackMessagesToastShow = createAction(
  'feedbackMessages/toast/show',
  (message: ToastMessage) => ({ payload: message })
)
